module.exports = __webpack_public_path__ + "static/lakiernictwo-1f2d98fbc869fb066855966a273e06a6.jpg";